import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchAPI, getStrapiMedia } from '../../utils/api';

const LeadershipDetails = () => {
    const { id } = useParams();
    const [leader, setLeader] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await fetchAPI(`/teams/${id}`, {
                    populate: '*'
                });

                if (response.data) {
                    setLeader(response.data);
                }
            } catch (error) {
                console.error("Error fetching leader data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            getData();
        }
    }, [id]);

    if (loading) return <div className="loader">Loading...</div>;
    if (!leader) return <div>Leader not found.</div>;

    const imageUrl = getStrapiMedia(leader.Image || leader.image);

    return (
        <section className="leadership-details py-5 mt-5">
            <div className="container">
                <div className="row align-items-center">
                    {/*<div className="col-12 col-md-5 mb-4 mb-md-0">
                        <div className="leadership-image">
                            {imageUrl ? (
                                <img src={imageUrl} alt={leader.Name || leader.name} className="img-fluid" />
                            ) : (
                                <div className="placeholder-image" style={{ width: '100%', height: '400px', backgroundColor: '#f0f0f0' }}></div>
                            )}
                        </div>
                    </div>*/}
                    <div className="col-12 col-md-7 mt-5">
                        <div className="leadership-content pl-md-5">
                            <h2 className="title mb-3">{leader.Name || leader.name}</h2>
                            <h5 className="position text-primary mb-4">{leader.Role || leader.role}</h5>
                            <div className="bio">
                                <p>{leader.Bio || leader.bio || leader.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LeadershipDetails;
